require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/cart-cross-sell/cart-cross-sell.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/cart-cross-sell/cart-cross-sell.legacy.js
// module id = 696
// module chunks = 31